import { render } from "./UserStatsView.vue?vue&type=template&id=9bc821c8&scoped=true"
import script from "./UserStatsView.vue?vue&type=script&lang=js"
export * from "./UserStatsView.vue?vue&type=script&lang=js"

import "./UserStatsView.vue?vue&type=style&index=0&id=9bc821c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc821c8"]])

export default __exports__